import {ActionStatus} from '@colonist/game-base-types'
import {Sound} from '../../../Sound'
import {UIGameFlickerAnimation} from '../../../ui_canvas_engine/animation/UIGameFlickerAnimation'
import {UIGameManager} from '../../UIGameManager'
import {UIGameActionButtonView} from '../../ui_game_actions/UIGameActionButtonView'
import {GameStateEnums} from '../../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {TurnState} from '@colonist/game-states'

export class UIGameBeginnerModeActionButtonsHelper {
    private readonly uiGameManager: UIGameManager
    private readonly button: UIGameActionButtonView
    shouldRevealButton: boolean = false

    constructor(uiGameManager: UIGameManager, actionButton: UIGameActionButtonView) {
        this.uiGameManager = uiGameManager
        this.button = actionButton
    }

    revealButton() {
        if(!this.shouldRevealButton) return
        this.button.visible = this.shouldRevealButton
        this.shouldRevealButton = false
        new UIGameFlickerAnimation(this.button).start()
        Sound.playSound(Sound.SoundType.RoomGetReady)
    }

    triggerGuideBubbleIfCantPerform(actionStatus: ActionStatus) {
        const canPerformBuyAction = this.canPerformBuyAction(actionStatus)
        if(!canPerformBuyAction) this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.BeginnerModeForceOpenGuideBubble)
    }

    private canPerformBuyAction(actionStatus: ActionStatus): boolean {
        const isMyTurn = this.uiGameManager.gameController.isMyTurn
        const isTurnState = this.uiGameManager.gameController.currentState.turnState == TurnState.Turn
        return isMyTurn && isTurnState && actionStatus.canTakeAction
    }
}
